import { AutocompleteField as SharedAutocompleteField, styled } from '@harver/shared-ui';

export const AutocompleteField = styled(SharedAutocompleteField)`
    .MuiAutocomplete-popupIndicator {
        color: ${({ theme }) => theme.colors.primary['500']};
    }
`;
